import { React, Component, Container, _ } from "utils";
import {
  ChatStore,
  AuthStore,
  Creators,
  FairStore,
  SelectedPavilionStore,
} from "model";
import { Loading } from "components";
import Facebook from "react-facebook-login";
import GoogleLogin from "react-google-login";
import "./chat.less";

class Chat extends Component {
  static getStores() {
    return [ChatStore, AuthStore, FairStore];
  }

  static calculateState(state, props) {
    var { stand } = props.match.params;
    var messages = [];

    if (stand == ChatStore.getStandSlug()) {
      messages = ChatStore.getMessagesGroupedByDay();
    }

    var chatroom = SelectedPavilionStore.getStand(stand);

    let fairData = FairStore.getFairData();
    let isFairActive = fairData
      ? fairData.active
        ? fairData.active
        : false
      : false;

    return {
      auth: AuthStore.isAuthorized() == false,
      loading: AuthStore.isLoading(),
      messages: messages,
      chatroom: chatroom,
      chatHash: ChatStore.getChatHash(),
      msg: AuthStore.getMessage(),
      chatNotificationsEnabled: ChatStore.getChatNotificationsEnabled(),
      isFairActive,
    };
  }

  componentDidMount() {
    var { pavilion, stand } = this.props.match.params;

    setTimeout(() => {
      Creators.chatRoomChanged(pavilion, stand);
    });
    Creators.getChatNotificationSetting();
    Creators.clearChatHash();
    this.timer = setInterval(Creators.reloadMessages, 5000);
  }

  componentDidUpdate(prevProps, prevState) {
    var box = $(".page > .box");

    if (box.css("overflow-y") == "auto") {
      box.scrollTop(box[0].scrollHeight);
    } else {
      $(window).scrollTop($("body")[0].scrollHeight);
    }

    if (prevState.auth !== this.state.auth) {
      const { stand } = this.props.match.params;
      setTimeout(() => {
        Creators.getChatInfo(stand);
      });
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    Creators.chatRoomChanged(null);
  }

  setSendRef = (input) => {
    this.send = input;
  };

  setChatNotificationSetting = (event) => {
    Creators.toggleChatNotificationSetting();
  };

  sendMessage = (event) => {
    event.preventDefault();

    var send = $(this.send);
    var msg = send.val();

    send.val("");

    var { stand } = this.props.match.params;
    Creators.sendMessage(stand, msg);

    console.log(msg);
  };

  render() {
    var {
      auth,
      loading,
      messages,
      chatHash,
      chatroom,
      msg,
      chatNotificationsEnabled,
      isFairActive,
    } = this.state;

    let chatVideoLink = "https://meet.jit.si/" + chatHash;
    if (loading) {
      return <Loading visible="true" />;
    } else if (!isFairActive) {
      return <div className="site-alert">{_("Fair closed")}</div>;
    } else if (auth) {
      return <AuthForm msg={msg} />;
    } else {
      var title = chatroom ? chatroom.title : _("Chat");
      let notificationChecked = chatNotificationsEnabled === 1;
      return (
        <div className="col-12 chat-box">
          {chatHash ? (
            <div style={{ display: "hidden" }} className="video-chat">
              <a href={chatVideoLink} target="_blank">
                <i className="fa fa-video-camera" aria-hidden="true"></i>
                <span>{_("Video chat")}</span>
              </a>
            </div>
          ) : null}
          <div className="title">{title}</div>
          <Messages data={messages} />
          <div className="send">
            <form onSubmit={this.sendMessage}>
              <input
                ref={this.setSendRef}
                type="text"
                className="form-control form-control-lg"
              />
              <i onClick={this.sendMessage} className="fa fa-paper-plane"></i>
            </form>
            <ChatStatus data={chatroom} />
          </div>
          <div className="notification-indicator">
            {chatNotificationsEnabled !== null ? (
              <input
                type="checkbox"
                checked={notificationChecked}
                onChange={this.setChatNotificationSetting}
              />
            ) : (
              <i className="fa fa-spin fa-spinner"></i>
            )}
            <span>{_("I want to receive email notifications")}</span>
          </div>
        </div>
      );
    }
  }
}

export function AuthForm({ msg }) {
  var css = [];

  if (msg == null) {
    msg = _("Sign in required to access this page");
  } else {
    css.push("alert alert-danger");
  }

  return (
    <div className="col-12">
      <h1 className="display-4">{_("Sign in")}</h1>
      <div className={css.join(" ")}>{msg}</div>
      <AuthProviders />
    </div>
  );
}

function ChatStatus({ data }) {
  if (data && data.chatOnline == 0) {
    return (
      <div className="status offline">
        {_(
          "{title} is currently offline. Leave a message and you will receive a notification when replied.",
          { title: data.title }
        )}
      </div>
    );
  } else {
    return null;
  }
}

function Messages({ data }) {
  if (data.length > 0) {
    var days = data.map((item) => {
      return (
        <div key={item.day} className="day">
          <div className="date">{item.day}</div>
          <DayMessages data={item.items} />
        </div>
      );
    });

    return <div className="days">{days}</div>;
  } else {
    return null;
  }
}

function DayMessages({ data }) {
  var items = data.map((item) => {
    var css = ["msg"];

    if (item.stand == null) {
      css.push("customer");
    } else {
      css.push("admin");
    }

    const content =
      item.content === "{CHAT_INVITE}"
        ? _("You've been invited to a video chat")
        : item.content;

    return (
      <div key={item.id} className={css.join(" ")}>
        <div className="content">{content}</div>
      </div>
    );
  });

  return <div className="dm">{items}</div>;
}

function handleFacebookResponse(args) {
  console.log('handleFacebookResponse', args);
  Creators.facebook(args.accessToken);
}

function handleGoogleResponse(args) {
  console.log('handleGoogleResponse', args);
  if (args.accessToken) {
    Creators.google(args.accessToken);
  }
}

function AuthProviders() {
  if (AuthStore.isLoading() || AuthStore.isAuthorized()) {
    return null;
  } else {
    let providers = AuthStore.getProviders();

    let fb = providers.fb ? (
      <div>
        <Facebook
          appId={providers.fb}
          fields="name,email"
          scope="public_profile,email"
          isMobile={false}
          disableMobileRedirect
          textButton={_("Login with Facebook")}
          callback={handleFacebookResponse}
          cssClass="btn text-light facebook"
        />
      </div>
    ) : null;

    let google = providers.google ? (
      <div>
        <GoogleLogin
          clientId={providers.google}
          buttonText={_("Login with Google")}
          onSuccess={handleGoogleResponse}
          onFailure={handleGoogleResponse}
          className="btn text-light google"
        />
      </div>
    ) : null;

    return (
      <div className="auth-providers">
        {fb}
        {google}
      </div>
    );
  }
}

export default Container.create(Chat, { withProps: true });



// WEBPACK FOOTER //
// ./src/modules/components/activities/chat.js